module.exports = __webpack_public_path__ + "img/paul_mccartney-freshen-up.62646628.jpg";